import './mask-field-text.scss'

import { defineComponent, PropType } from 'vue'
import _ from 'lodash';

import { EntityField, EntityFieldStatus, TranslatedString, createTranslatedString, editTranslatedString, getTranslatedString } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const MaskFieldText = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
            required: true,
        },
        // fieldValue holds the raw stored value for this record-mask field, whose shape depends on
        // the entity field's own type (string, TranslatedString, ...), so a broad type is the honest one.
        fieldValue: {} as { type?: PropType<any> },
        editing: {
            type: Boolean,
        },
        getStatus: {
            type: Function as PropType<(entityField: EntityField) => EntityFieldStatus>,
            required: true,
        },
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-text.html'),
    computed: {
        value: {
            get(): String {
                if(this.entityField.type?.type === "TranslatedString") {
                    return getTranslatedString(this.fieldValue, this.getAppLocale())
                }
                return _.get(this.fieldValue, 'value') ?? this.fieldValue ?? ""
            },
            set(input: String) {
                let returnValue: TranslatedString | String = input

                if(this.entityField.type?.type === "TranslatedString") {
                    if (this.fieldValue) {
                        returnValue = _.cloneDeep(this.fieldValue)
                        editTranslatedString(returnValue as TranslatedString, input as string, this.getAppLocale())
                    } else {
                        returnValue = createTranslatedString(this.getAppLocale(), input as string)
                    }
                }

                this.$emit("value-change", {
                    abstractEntity: this.entityField.abstractEntity,
                    fieldPath: this.entityField.path,
                    value: returnValue,
                })
            },
        },
    },
    methods: {
        isReadonly(entityField: EntityField) {
            return entityField.isReadOnly || this.getStatus(entityField).disabled
        },
        infoMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).disabledMessage
        },
        errorMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).errorMessage
        },
        hasError(entityField: EntityField) {
            return this.getStatus(entityField).error
        },
    },
    watch: {
        fieldValue() {
            // sometimes the b-modal doesn't update if value is undefined
            // and it still displays old value
            this.$forceUpdate()
        },
    },
})
